export default __webpack_public_path__ + "static/media/hvar3.ce205ece.jpg";